import { PdOrderContacts } from "./pd-order-contacts/PdOrderContacts.js";
//#region src/pd-order-contacts/pd-order-contacts.ts
var tag = "pd-order-contacts";
if (!customElements.get(tag)) customElements.define(tag, PdOrderContacts);
//#endregion
export { PdOrderContacts };
